import { MetodosValidacionesIdentidad } from './../../_enums/enum';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import {ConfirmationService, SelectItem} from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import {AppSettingService} from '../../_services/app-setting.service';
import {Canal} from '../../_models/canal';
import {ListaItem} from '../../_models/lista-item';
import {CanalService} from '../../_services/canal.service';
import {ListaService} from '../../_services/lista.service';
import {MatrizIdentidadService} from '../../_services/matriz-identidad.service';
import {forkJoin} from 'rxjs';

@Component( {
  selector: 'app-matriz-identidad-agregar',
  templateUrl: 'matriz-identidad-agregar.component.html'
} )

export class MatrizIdentidadAgregarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  agregar = false;
  listCanes: Canal[] = [];
  lisCanales: SelectItem[];
  listTipoCliente: ListaItem[] = [];
  lisTipoCliente: SelectItem[];
  listModoAutenticacion: ListaItem[] = [];
  lisModoAutenticacion: SelectItem[];
  listaTiposCuestionarios: ListaItem[] = [];
  lisTiposCuestionarios: SelectItem[];
  matrizIdentidad: any;
  listaMatrizIdentidad: any[] = [];
  listaMatrizIdentidadTemp: any[] = [];

  formulario: FormGroup;
  submitted = false;
  carTabla = true;
  validacionIdentidad = false;
  esConfronta = false;
  llaveExiste = false;
  columnas: any[];
  mensajeError: string;

  constructor( private canalesServicio: CanalService,
               private listaService: ListaService,
               private matrizIdentidadService: MatrizIdentidadService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private navServicio: NavService,
               public appSettingService: AppSettingService) {
  }

  ngOnInit(): void {
    this.cargarInformacionInicial();
  }

  cargarInformacionInicial() {

    this.formulario = this.fb.group( {
      idCanal: [[], [Validators.required]],
      idTipoCliente: [[], [Validators.required]],
      idModoAutenticacion: [ this.matrizIdentidad ? this.matrizIdentidad.idModoAutenticacion : null, [ Validators.required ] ],
      idModoAutenticacionOpcional: [ this.matrizIdentidad ? this.matrizIdentidad.idModoAutenticacionOpcional : null ],
      idTipoCuestionario: [ this.matrizIdentidad ? this.matrizIdentidad.idTipoCuestionario : null ],
      indicadorMetodoOpcional: [ this.matrizIdentidad ? this.matrizIdentidad.indicadorMetodoOpcional : false],
      indicadorTomaDatos: [ this.matrizIdentidad ? this.matrizIdentidad.indicadorTomaDatos : false],
      indicadorValidacionIdentidad: [ this.matrizIdentidad ? this.matrizIdentidad.indicadorValidacionIdentidad : false],
      indicadorHabilitado: [ this.matrizIdentidad ? this.matrizIdentidad.indicadorHabilitado : false ],
      indicadorObligatorio: [ this.matrizIdentidad ? this.matrizIdentidad.indicadorObligatorio : false ],
    } );

    this.columnas = [
      { field: 'nombreModoAutenticacion', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_MODOAUTENTICACION' ), sort: true },
      { field: 'indicadorValidacionIdentidad', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_VALIDACIONIDENTIDAD' ), sort: true },
      { field: 'indicadorTomaDatos', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_TOMADATOS' ), sort: true },
      { field: 'indicadorObligatorio', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_INDICADOROBLIGATORIO' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.canalesServicio.listadoCanalesHabilitados(),
      this.listaService.getMasterDetails( 'ListasTiposClientes' ),
      this.listaService.getMasterDetails( 'ListasModosAutenticaciones' ),
      this.matrizIdentidadService.listado(),
      this.listaService.getMasterDetails( 'ListasTiposCuestionarios' )
      ).subscribe( ( [ canales, tipoCliente, modoAutenticacion, matrizIdentidad, tiposCuestionarios ] ) => {
      this.listCanes = canales;
      this.listTipoCliente = tipoCliente;
      this.listModoAutenticacion = modoAutenticacion;
      this.listaMatrizIdentidad = matrizIdentidad;
      this.listaTiposCuestionarios = tiposCuestionarios;
      this.lisCanales = [];
      canales.map( ( s: Canal ) => {
        this.lisCanales.push( { label: s.nombre, value: s.idCanal } );
      } );
      this.lisTipoCliente= [];
      tipoCliente.map( ( s: ListaItem ) => {
        this.lisTipoCliente.push( { label: s.nombre, value: s.idLista } );
      } );
      this.lisModoAutenticacion = [];
      modoAutenticacion.map( ( s: ListaItem ) => {
        this.lisModoAutenticacion.push( { label: s.nombre, value: s.idLista } );
      } );
      this.lisTiposCuestionarios = [];
      tiposCuestionarios.map( ( s: ListaItem ) => {
        this.lisTiposCuestionarios.push( { label: s.nombre, value: s.idLista } );
      } );
      this.carInformacionInicial = false;
    } );

  }

  validarMetodoEspecifico() {
    const confrontaUltra = this.listModoAutenticacion.find((x) => x.idLista === this.f.idModoAutenticacion.value && x.codigo === MetodosValidacionesIdentidad.CONFRONTA);

    if (!confrontaUltra) {
      this.esConfronta = false;
      this.f.indicadorMetodoOpcional.setValue(false);
      this.f.idTipoCuestionario.setValidators([]);
      this.f.idTipoCuestionario.updateValueAndValidity();
      return;
    }
    this.esConfronta = true;
    this.f.idTipoCuestionario.setValidators([Validators.required]);
    this.f.idTipoCuestionario.updateValueAndValidity();
  }

  validarCheckOpcional() {
    if (this.f.indicadorMetodoOpcional.value) {
      this.f.idModoAutenticacionOpcional.setValidators([Validators.required]);
      this.f.idModoAutenticacionOpcional.setValue(null);
      this.f.idModoAutenticacionOpcional.updateValueAndValidity();
      this.f.idTipoCuestionario.setValidators([Validators.required]);
      this.f.idTipoCuestionario.setValue(null);
      this.f.idTipoCuestionario.updateValueAndValidity();
    } else {
      this.f.idModoAutenticacionOpcional.setValidators(null)
      this.f.idModoAutenticacionOpcional.setValue(null);
      this.f.idModoAutenticacionOpcional.updateValueAndValidity();
      this.f.idTipoCuestionario.setValidators(null)
      this.f.idTipoCuestionario.setValue(null);
      this.f.idTipoCuestionario.updateValueAndValidity();
    }
  }

  onSubmit() {
    this.submitted = true;
    this.agregar = true;
    const forData = this.formulario.value;
    if ( !this.f.indicadorTomaDatos.value && !this.f.indicadorValidacionIdentidad.value ){
      this.validacionIdentidad = true;
    } else {
      this.validacionIdentidad = false;
    }
    if (this.formulario.valid && !this.validacionIdentidad) {
      const formulario = this.formulario.getRawValue();
      let matriz = {} as any;
      matriz.idModoAutenticacion = this.f.idModoAutenticacion.value;
      matriz.idModoAutenticacionOpcional = this.f.idModoAutenticacionOpcional.value;
      matriz.indicadorMetodoOpcional = this.f.indicadorMetodoOpcional.value;
      matriz.idTipoCuestionario = this.f.idTipoCuestionario.value;
      matriz.indicadorTomaDatos = this.f.indicadorTomaDatos.value;
      matriz.indicadorValidacionIdentidad = this.f.indicadorValidacionIdentidad.value;
      matriz.indicadorObligatorio = this.f.indicadorTomaDatos.value ? this.f.indicadorObligatorio.value : false;
      matriz.indicadorHabilitado = this.f.indicadorHabilitado.value;
      matriz.nombreModoAutenticacion = this.listModoAutenticacion.find(mo => mo.idLista ===  this.f.idModoAutenticacion.value).nombre;
      this.validacionIdentidad = false;
      this.mensajeError = null;
      forData.idCanal.forEach(canal => {
        forData.idTipoCliente.forEach(tipoCliente => {
          matriz.idCanal = canal;
          matriz.idTipoCliente = tipoCliente;
          if (this.validarLlaveNegocio(matriz)){
            this.validacionIdentidad = true;
          }
        });
      });
      if (!this.validacionIdentidad){
        this.listaMatrizIdentidadTemp.push(matriz);
        this.lisModoAutenticacion = [];
        this.listModoAutenticacion.map( ( s: ListaItem ) => {
          if ( !this.listaMatrizIdentidadTemp.find(ma => ma.idModoAutenticacion === s.idLista)){
            this.lisModoAutenticacion.push( { label: s.nombre, value: s.idLista } );
          }
        } );
        this.formulario.reset();
        this.formulario.controls.idCanal.setValue(forData.idCanal);
        this.formulario.controls.idTipoCliente.setValue(forData.idTipoCliente);
        this.formulario.controls.indicadorTomaDatos.setValue(false);
        this.formulario.controls.indicadorValidacionIdentidad.setValue(false);
        this.formulario.controls.indicadorHabilitado.setValue(false);
        this.submitted = false;
        this.agregar = false;
      } else {
        this.agregar = false;
      }
    } else {
      this.agregar = false;
    }
  }

  add() {

    this.guardando = false;
    if (this.listaMatrizIdentidadTemp.length > 0 ) {

      const listaTem = Object.assign( [], this.listaMatrizIdentidadTemp );
      this.listaMatrizIdentidadTemp = [];
      const forData = this.formulario.value;
      this.validacionIdentidad = false;
      this.mensajeError = null;
      forData.idCanal.forEach(canal => {
        forData.idTipoCliente.forEach(tipoCliente => {
          listaTem.map(( matriz: any ) => {
            const matrizTemp = Object.assign({}, matriz);
            matrizTemp.idCanal = canal;
            matrizTemp.idTipoCliente = tipoCliente;
            matrizTemp.indicadorMetodoOpcional = matrizTemp.indicadorMetodoOpcional ? matrizTemp.indicadorMetodoOpcional : false;
            matrizTemp.indicadorObligatorio = matrizTemp.indicadorObligatorio ? matrizTemp.indicadorObligatorio : false;
            matrizTemp.indicadorTomaDatos = matrizTemp.indicadorTomaDatos ? matrizTemp.indicadorTomaDatos : false;
            matrizTemp.indicadorValidacionIdentidad = matrizTemp.indicadorValidacionIdentidad ? matrizTemp.indicadorValidacionIdentidad : false;
            if (this.validarLlaveNegocio(matrizTemp)){
              this.validacionIdentidad = true;
            } else {
              this.listaMatrizIdentidadTemp.push(matrizTemp);
            }
          } );
        } );
      } );
      if (!this.validacionIdentidad){
        this.matrizIdentidadService.bulk(this.listaMatrizIdentidadTemp).subscribe( res => {
          this.navServicio.setMesage( 1 );
          this.location.back();
        } );
      } else {
        this.guardando = false;
      }

    } else {
      this.navServicio.setMesage( 0,{
          severity: 'info',
          summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.MGG_ERRPRTABLA' )
       } );
      this.guardando = false;
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'matriz-identidad',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  get f() {
    return this.formulario.controls;
  }


  validarLlaveNegocio( matriz : any) : boolean {
    const idCanal = matriz.idCanal;
    const idModoAutenticacion = matriz.idModoAutenticacion;
    const idTipoCliente = matriz.idTipoCliente;
    const dato1 = this.listaMatrizIdentidad.find( x => x.idCanal === idCanal
      && x.idModoAutenticacion === idModoAutenticacion
      && x.idTipoCliente === idTipoCliente);
    if ( dato1 ){
      if (this.mensajeError){
        this.mensajeError = this.mensajeError = ", El Canal " + this.listCanes.find(ca => ca.idCanal === idCanal).nombre + " "
          + ", El tipo de Cliente " + this.listTipoCliente.find(ti => ti.idLista === idTipoCliente).nombre + " "
          + " y el Modo de Autenticación ya esta configurado";
      } else {
        this.mensajeError = "El Canal " + this.listCanes.find(ca => ca.idCanal === idCanal).nombre + " "
          + ", El tipo de Cliente " + this.listTipoCliente.find(ti => ti.idLista === idTipoCliente).nombre + " "
          + " y el Modo de Autenticación ya esta configurado";
      }
      return true;
    } else {
      return false;
    }
  }


  disable( row: any ): void {
    this.conServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Matriz de Validación identidad',
      icon: 'fa fa-question-circle',
      key: 'matriz-identidad',
      accept: () => {
        for (var i = 0; i < this.listaMatrizIdentidadTemp.length; i++) {
          if (this.listaMatrizIdentidadTemp[i].idModoAutenticacion === row.idModoAutenticacion) {
            this.listaMatrizIdentidadTemp.splice(i, 1);
               this.lisModoAutenticacion.push( { label: this.listModoAutenticacion.find(mo => mo.idLista === row.idModoAutenticacion).nombre,
              value: this.listModoAutenticacion.find(mo => mo.idLista === row.idModoAutenticacion).idLista } );
          }
        }
      }
    } );
  }

  setearIndicadorObligatorio() {
    if ( !this.f.indicadorTomaDatos.value ) {
      this.f.indicadorObligatorio.setValue( false );
    }
    this.metodoCheckeado();
  }

  metodoCheckeado()
  {
    this.validacionIdentidad = !this.f.indicadorValidacionIdentidad.value && !this.f.indicadorTomaDatos.value && !this.f.indicadorObligatorio.value && !this.f.indicadorHabilitado.value;
  }

}
